module.exports = __webpack_public_path__ + "img/ramhee.49dc0bdf.png";